<div class="button-add-container">
	<button class="btn btn-sm cv-btn-blue" (click)="onAddLender()">
		<i class="fas fa-plus-square"></i> Add New Lender
	</button>
</div>

<div class="inbox-datatable__main-content scrollable-component">
  <div class="row">
    <div class="card">
		<div class="card-body">
			<div class="row">
				<div class="col-sm-6">
					<cv-multiselect-search
					  [required]="true"
					  [label]="'Default Acuity Branch Name when the origin is AppScope'"
					  [placeholder]="'Select a branch'"
					  [options]="acuityLenderBranchesList"
					  [optionText]="'title'"
					  [optionValue]="'id'"
					  [singleSelectMode]="true"
					  [values]="selectedAppScopeBranch"
					  (valuesChange)="onAppScopeBranchSelected($event)"
					  [getOptionsFunction]="lenderService.getAcuityLenderBranches"
					>
					</cv-multiselect-search>
				  </div>
				  <div class="col-sm-6">
					  <cv-multiselect-search
						[required]="true"
						[label]="'Default Acuity Branch Name when the origin is ClassApi'"
						[placeholder]="'Select a branch'"
						[options]="acuityLenderBranchesList"
						[optionText]="'title'"
						[optionValue]="'id'"
						[singleSelectMode]="true"
						[values]="selectedAcuityBranch"
						(valuesChange)="onAcuityBranchSelected($event)"
						[getOptionsFunction]="lenderService.getAcuityLenderBranches"
					  >
					  </cv-multiselect-search>
					</div>
			</div>

			<div class="button-container container-uptade-lender-config">
				<button
				  class="btn btn-sm cv-btn-blue"
				  [disabled]="saving || !isDirty"
				  (click)="saveConfiguration()"
				>
				  <div *ngIf="saving" class="loading-wrapper">
					<i class="fas fa-spinner"></i>
				  </div>
				  Save
				</button>
			</div>

		</div>
	</div>
  </div>

  <div class="inbox-filter__content">
    <div class="filter">
      <div class="input-filter__container">
        <cv-input
          [value]="filterLenders.searchTextAcuityName"
          [type]="'text'"
          [name]="'acuityName'"
          [maxlength]="100"
          [placeholder]="'Search by Acuity Branch Name'"
          (controlKeyup)="onSearchTextChange('acuityName', $event)"
        ></cv-input>
      </div>
    </div>

    <div class="filter">
      <div class="input-filter__container">
        <cv-input
          [value]="filterLenders.searchTextScopeName"
          [type]="'text'"
          [name]="'scopeName'"
          [maxlength]="100"
          [placeholder]="'Search by AppScope Client Name'"
          (controlKeyup)="onSearchTextChange('scopeName', $event)"
        ></cv-input>
      </div>
    </div>
  </div>

  <ag-grid-angular
    #grid
    class="ag-theme-balham custom-grid"
    (gridReady)="onInitializeGrid($event)"
    (gridSizeChanged)="resizeToFitColumns()"
    [pagination]="true"
    [suppressPaginationPanel]="true"
    [gridOptions]="gridOptions"
    [domLayout]="'autoHeight'"
    [rowData]="gridData"
  >
  </ag-grid-angular>
  <cv-grid-pagination
    [pagination]="gridPagination.pagination"
    (onPaginationChange)="onPaginationChange($event)"
  ></cv-grid-pagination>
</div>
